export default "__VITE_ASSET__C5a8TSKf__"